export const CLASSNAME = {
  NOT_TRANSLATE: 'notranslate',
  ALREADY_TRANSLATED: 'notranslate already-translated',
};
